import Button from 'components/Button';
import classNames from 'styles/utils/classNames';
import { EnablePromptProps } from './props';

const EnablePrompt: React.FC<EnablePromptProps> = ({ onSubscribe, className, standalone }) => {
  return (
    <div
      className={classNames(
        'flex h-fit flex-col gap-ds-xl p-ds-xl',
        className,
        standalone &&
          'rounded-[24px] border border-color-border-input-lightmode shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode',
      )}
    >
      <h3 className="typography-product-heading-compact-desktop  text-color-brand-primary">
        Enable content subscribtion
      </h3>
      <p className="text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        Monetize your content by offering it to players as part of a subscription.
      </p>
      <Button variant="brand" size="lg" onClick={onSubscribe}>
        Start
      </Button>
    </div>
  );
};

export default EnablePrompt;
